import { Component, Input, SimpleChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-policy-search-add',
  templateUrl: './ui-policy-search-add.component.html',
  styleUrls: ['./ui-policy-search-add.component.scss']
})
export class UiPolicySearchAddComponent implements OnInit {

  @Input() unifiedSearch: boolean = true;

  constructor() { }

  ngOnInit() {
    this.initTableData();
    this.loader();
  }

  isLoading = false;
  /* Handle Search */
  searchedFor(d){
    this.loader();
  }
  loader() {
    this.isLoading = true;
    setTimeout( ()=>{this.isLoading = false},640 );
  }


  nestedTableData = [];
  innerTableData = [];
  initTableData() {
    for (let i = 0; i < 4; ++i) {
      this.nestedTableData.push({
        key : i,
        name : i==0?'Umang Desai':i==1?'Rahul Vohres':'Nitin Kamat',
        policy : i==0?'P9200199':`P2${i+19}8892`,
        product : 'StandardLife',
        email : i==0?'umang007@gmail.com':'poe'+(i*113)+'@gmail.com',
        phone : i==0?'9800998214':`9889`+i*12929,
        expiry : i==0?'03 Dec 2021':`${i+2} Oct 2023`,
        expand : i==0,
      });
    }
    for (let i = 0; i < 3; ++i) {
      this.innerTableData.push({
        key : i,
        policy: 'P9200199/'+(i+1)*459+'/JMSP',
        product : 'StandardLife+',
        name : i==0?'Sheetal Desai':i==1?'Rohan Desai':'Shruti Desai',
        expiry : `0${i+2} Dec 2021`,
      });
    }
  }

  tableData ={
    keys: [
      {name:"Customer Name", key:'custName'},
      {name:"Email", key:'custEmail'},
      {name:"Phone", key:'custPhone'},
      {name:"Policies", key:'policy'},
      {name:"Policy Commencement", key:'policyCommencement'},
    ],
    values: [
      {custName: 'Umang Desai', custEmail: 'umang007@gmail.com', custPhone: '9800998214', policy: ['P27009189'], policyCommencement: "19 Dec 2018",},
      {custName: 'Rahul Vohres', custEmail: 'rahul@rventures.com', custPhone: '9872700091', policy: ['P67090167','P67090563'], policyCommencement: "11 Mar 2020",},
      {custName: 'Nitin Kamat', custEmail: 'nitin@zerothe.com', custPhone: '9877682820', policy: ['P210901S3'], policyCommencement: "12 Apr 2019",},
      {custName: 'Seren Wade', custEmail: 'wsere@gmail.com', custPhone: '8009821112', policy: ['P00789056'], policyCommencement: "01 Jan 2019",},
    ],
  };



  /* COPIED -- OLD SEARCH METHOD -- DEPRECATED */
  /* Search by Customer or Policy */
  searchCustOrPolicy:string = "customer";
  searchCustOrPolicyLoading:boolean = false;
  searchCustOrPolicyChanged() {
    this.searchCustOrPolicyLoading = true;
    this.showCustomerPolicies = false;
    setTimeout(() => { this.searchCustOrPolicyLoading = false }, 1200);
  }
  showCustomerPolicies:boolean = false;
  showCustomerPoliciesName:string = '';
  viewAddCustomersPolicies(namePassed) {
    this.showCustomerPolicies = true;
    this.showCustomerPoliciesName = namePassed;
  }
  dataSet = [1,2,3];
  tmpPolicy = "A";
  policyPanel(i) { console.log("policyPanel") }
  /* COPIED -- OLD SEARCH METHOD -- DEPRECATED */




}
